<template>
  <Modal :open="open" @close="$emit('close')" size="medium" :show-close-button="true">
    <OrderKitForm v-if="showOrderKitForm" @back="showOrderKitForm = false" />

    <template v-else>
      <!-- Search bar -->
      <div class="border-b border-gray-200">
        <div class="relative">
          <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <SearchIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            v-model="searchQuery"
            type="text"
            class="block w-full pl-10 pr-3 py-3 border-0 text-sm placeholder-gray-400 focus:outline-hidden focus:ring-0"
            placeholder="Rechercher et naviguer..."
            @keydown.escape="$emit('close')"
            ref="searchInput"
          />
        </div>
      </div>

      <!-- Actions list -->
      <div class="overflow-y-auto">
        <div class="pt-4">
          <h3 class="text-xs font-light text-gray-500 tracking-wide mb-3">Actions</h3>
          <div class="space-y-1">
            <div
              v-for="(action, index) in filteredActions"
              :key="index"
              @click="handleActionClick(action)"
              class="px-3 py-2 rounded-md cursor-pointer text-sm transition-colors text-black hover:bg-gray-50"
            >
              {{ action.label }}
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { SearchIcon } from "@heroicons/vue/outline";
import { Modal } from "@estaly/ui";
import OrderKitForm from "./OrderKitForm.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SearchIcon,
    Modal,
    OrderKitForm,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close"],
  data() {
    return {
      searchQuery: "",
      showOrderKitForm: false,
      actions: [
        {
          label: "🛒 Faire une vente / Envoyer un devis",
          route: "/pos/subscription",
        },
        {
          label: "💰 Voir mes primes",
          route: "/pos/retributions",
          permission: "retributions",
        },
        {
          label: "📊 Voir ma grille de primes",
          route: "/pos/retribution-configurations",
          permission: "retributions",
        },
        {
          label: "🔍 Rechercher un contrat",
          route: { path: "/pos/plan-sales", query: { focusSearch: "true" } },
        },
        {
          label: "🔄 Déclarer un échange de produit",
          route: { path: "/pos/plan-sales", query: { focusSearch: "true", action: "productExchange" } },
        },
        {
          label: "🏦 Voir les paiements SEPA (via RIB) en attente",
          route: "/pos/leads",
        },
        {
          label: "👤 Ajouter un vendeur",
          route: { path: "/pos/sellers", query: { action: "add" } },
        },
        {
          label: "👤 Modifier / Supprimer un vendeur",
          route: "/pos/sellers",
        },
        {
          label: "🛠️ Rechercher un sinistre",
          route: { path: "/pos/claims", query: { tab: "all", focusSearch: "true" } },
        },
        {
          label: "📦 Commander un KIT de PLV",
          route: null, // specific action
        },
        {
          label: "📄 Voir les conditions des offres",
          route: "/pos/contract-distributions",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("auth", ["currentUserHasPermission"]),
    ...mapGetters("businessVerticals", ["hasExternalPosOnlySubscription"]),
    filteredActions() {
      let availableActions = this.actions;

      if (this.hasExternalPosOnlySubscription) {
        availableActions = availableActions.filter((action) => action.route !== "/pos/subscription");
      }

      availableActions = availableActions.filter(
        (action) => !action.permission || this.currentUserHasPermission(action.permission),
      );

      if (!this.searchQuery.trim()) {
        return availableActions;
      }
      const query = this.searchQuery.toLowerCase();
      return availableActions.filter((action) => action.label.toLowerCase().includes(query));
    },
  },
  watch: {
    open(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.searchQuery = "";
          this.showOrderKitForm = false;
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      }
    },
  },
  methods: {
    handleActionClick(action) {
      if (!action.route) {
        this.showOrderKitForm = true;
        return;
      }

      this.$router.push(action.route);
      this.$emit("close");
    },
  },
};
</script>
